import React, { useContext } from "react";
import { PurchaseValidationContext } from "./PurchaseValidationContext";
import { InputAdornment, TextField } from "@mui/material";
import { Search } from "@mui/icons-material";
import { useSearchParams } from "../Hooks/useSearchParams";
import MixpanelService from "../utils/MixpanelService";

export const PurchaseValidationSearch = () => {
  const { searchInput, setSearchInput, setAccountModal } = useContext(PurchaseValidationContext);
  const [searchParams, setSearchParams] = useSearchParams();

  const handleInputChange = (e) => {
    MixpanelService.track("esp_horizon_purch_val_search_accessed");
    setSearchParams({ ...searchParams, search: e.target.value });
    setAccountModal(undefined);
    setSearchInput(e.target.value);
  };

  return (
    <TextField
      label=""
      value={searchInput}
      onChange={handleInputChange}
      onBlur={() => MixpanelService.track("esp_horizon_purch_val_search_exited")}
      placeholder="Search for a Pharmacy"
      className="my-4"
      style={{ width: 320 }}
      sx={{
        "& .MuiInputBase-root": {
          height: 36,
        },
      }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Search />
          </InputAdornment>
        ),
      }}
    />
  );
};
